import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import SponsorStrip from './components/SponsorStrip';
import SponsoredSpotlight from './components/SponsoredSpotlight';
import RegionSwitcher from './components/RegionSwitcher';
import EventsCalendar from './components/EventsCalendar';
import CommunityBulletin from './components/CommunityBulletin';
import LatestStories from './components/LatestStories';
import CategoryCircles, { WAYS_TO_PLAY, DISCOVER } from './components/CategoryCircles';
import PillarBlocks from './components/PillarBlocks';
import Watch from './components/Watch';
import ProCollective from './components/ProCollective';
import AskGreenSide from './components/AskGreenSide';
import Partners from './components/Partners';
import Quote from './components/Quote';
import Newsletter from './components/Newsletter';
import Founders from './components/Founders';

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-950 min-h-screen">
      <Header />
      <main>
        <Hero />
        <SponsorStrip />
        <RegionSwitcher />
        <EventsCalendar />
        <LatestStories />
        <Newsletter />
        <PillarBlocks />
        <SponsoredSpotlight />
        <CommunityBulletin />
        <Watch />
        <ProCollective />
        <Founders />
        <CategoryCircles id="courses" eyebrow="Ways to Play" title="Find Your Game" items={WAYS_TO_PLAY} tone="dark" />
        <AskGreenSide />
        <Partners />
        <Quote />
        <CategoryCircles id="resources" eyebrow="Discover" title="Explore GreenSide" items={DISCOVER} />
      </main>
      <Footer />
    </div>
  );
}